(function () {
    const CLASS = 'ps-wp-s-video-carousel-crpo';

    function addAutoplay(url) {
        if (!url) return '';
        return url.includes('?') ? url + '&autoplay=1' : url + '?autoplay=1';
    }

    function getSlidesPerView() {
        const w = window.innerWidth;

        if (w >= 1024) return 3;
        if (w >= 640) return 2;
        return 1;
    }

    // ✅ NEW: static layout width handler
    function applyStaticLayout(carousel, slidesPerView) {
        const wrapper = carousel.querySelector('.swiper-wrapper');
        const slides = carousel.querySelectorAll('.swiper-slide');

        if (!wrapper || !slides.length) return;

        wrapper.style.display = 'flex';
        wrapper.style.justifyContent = 'center';
        wrapper.style.gap = '16px';
        wrapper.style.flexWrap = 'wrap';

        let width = '100%';

        if (slidesPerView === 3) width = 'calc(33.333% - 11px)';
        if (slidesPerView === 2) width = 'calc(50% - 8px)';
        if (slidesPerView === 1) width = '90%';

        slides.forEach(slide => {
            slide.style.width = width;
            slide.style.flex = `0 0 ${width}`;
        });
    }

    function initCarousel(carousel) {
        if (!carousel || carousel.dataset.initialized) return;

        if (typeof Swiper === 'undefined') {
            console.warn('Swiper not loaded');
            return;
        }

        const totalSlides = carousel.querySelectorAll('.swiper-slide').length;
        const requiredSlides = getSlidesPerView();

        const nextBtn = carousel.querySelector('.ps-swiper-next');
        const prevBtn = carousel.querySelector('.ps-swiper-prev');

        // =========================
        // ❌ NOT ENOUGH SLIDES → NO SWIPER
        // =========================
        if (totalSlides <= requiredSlides) {

            carousel.dataset.initialized = 'static';

            // 🔥 REPLACED CENTER LOGIC WITH WIDTH-AWARE VERSION
            applyStaticLayout(carousel, requiredSlides);

            // hide nav + pagination
            if (nextBtn) nextBtn.style.display = 'none';
            if (prevBtn) prevBtn.style.display = 'none';

            const pagination = carousel.querySelector('.swiper-pagination');
            if (pagination) pagination.style.display = 'none';
        }

        // =========================
        // ✅ ENOUGH SLIDES → INIT SWIPER
        // =========================
        else {

            carousel.dataset.initialized = 'true';

            new Swiper(carousel, {
                slidesPerView: 1.2,
                spaceBetween: 16,
                loop: false,

                pagination: {
                    el: carousel.querySelector('.swiper-pagination'),
                    clickable: true
                },

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                },

                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                        centeredSlides: true
                    },
                    640: {
                        slidesPerView: 2.1,
                        centeredSlides: false
                    },
                    1024: {
                        slidesPerView: 3.2,
                        centeredSlides: false
                    }
                }
            });
        }

        // =========================
        // VIDEO PLAY LOGIC (UNCHANGED)
        // =========================
        carousel.querySelectorAll('.video-trigger').forEach((btn) => {
            btn.addEventListener('click', function () {

                stopAllVideos();

                const embed = btn.dataset.embed;
                const container = btn.nextElementSibling;

                if (!embed || !container) return;
                if (container.innerHTML.trim()) return;

                const src = addAutoplay(embed);

                container.innerHTML = `
                    <iframe
                        src="${src}"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                        loading="lazy"
                    ></iframe>
                `;

                container.hidden = false;
                btn.style.display = 'none';
            });
        });
    }

    function initAll() {
        document.querySelectorAll(`.${CLASS}`).forEach(initCarousel);
    }

    document.addEventListener('DOMContentLoaded', function () {
        initAll();

        if (document.body) {
            new MutationObserver(initAll).observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    });

})();


function stopAllVideos() {
    document.querySelectorAll('.video-container').forEach(container => {
        container.innerHTML = '';
        container.hidden = true;
    });

    document.querySelectorAll('.video-trigger').forEach(btn => {
        btn.style.display = 'block';
    });
}